/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_TitleInputs */

const en_domain_manager_title = /** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Command`)
};

const es_domain_manager_title = /** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de Dominio`)
};

const fr_domain_manager_title = /** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de domaine`)
};

const de_domain_manager_title = /** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain-Kommando`)
};

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const ja_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const zh_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const ar_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const id_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const it_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const ru_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const pt_domain_manager_title = en_domain_manager_title;

/** @type {(inputs: Domain_Manager_TitleInputs) => LocalizedString} */
const ko_domain_manager_title = en_domain_manager_title;

/**
* | output |
* | --- |
* | "Domain Command" |
*
* @param {Domain_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_title = /** @type {((inputs?: Domain_Manager_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_title(inputs)
	if (locale === "es") return es_domain_manager_title(inputs)
	if (locale === "fr") return fr_domain_manager_title(inputs)
	if (locale === "de") return de_domain_manager_title(inputs)
	if (locale === "ja") return ja_domain_manager_title(inputs)
	if (locale === "zh") return zh_domain_manager_title(inputs)
	if (locale === "ar") return ar_domain_manager_title(inputs)
	if (locale === "id") return id_domain_manager_title(inputs)
	if (locale === "it") return it_domain_manager_title(inputs)
	if (locale === "ru") return ru_domain_manager_title(inputs)
	if (locale === "pt") return pt_domain_manager_title(inputs)
	return ko_domain_manager_title(inputs)
});